import fetch from '@/plugin/axios'

export function getLoveMessageRecordList (data) {
  return fetch({
    url: '/api/member/love-message/admin/list',
    method: 'post',
    data
  })
}

export function getLoveMessageRecordStats (data) {
  return fetch({
    url: '/api/member/love-message/admin/stats',
    method: 'post',
    data
  })
}
